import styled from 'styled-components';

const HeaderWrapperStyled = styled.div`
  align-items: center;
  background-color: #2d1441;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 25px 0;
  width: 100%;
`;

const WavesContainerStyled = styled.div`
  margin-top: -300px;
  position: absolute;
  width: 100%;
  z-index: -1;
`;

const WavesHeaderSceneStyled = styled.div`
  background: white;
  position: relative;

  @media (min-width: 769px) {
    margin-top: -20px;
  }

  div {
    z-index: 0;
  }
`;

export { HeaderWrapperStyled, WavesContainerStyled, WavesHeaderSceneStyled };
